import { storyblokEditable } from '@storyblok/react';
import { FC } from 'react';
import slugify from 'react-slugify';

import Container from '@/components/elements/Container';
import Section from '@/components/elements/Section';
import StandardText, {
  StandardTextSize,
} from '@/components/elements/StandardText';

export interface MaskedImageProps {
  blok: any;
  content: any;
}

const MaskedImage: FC<MaskedImageProps> = ({ blok }) => {
  const id = blok._uid;
  const shapeMask = `${id}_shapeMask`;

  return (
    <Section
      id={slugify(blok.heading)}
      {...storyblokEditable(blok)}
      className="overflow-hidden"
    >
      <Container size="wider">
        <div
          className={`grid grid-rows-2 md:grid-rows-none md:grid-cols-2 w-full `}
        >
          <div className={`self-center pb-50 order-2 md:order-1`}>
            <StandardText blok={blok} size={StandardTextSize.MD} />
          </div>
          <div className={`order-1 md:order-2`}>
            <div className="w-screen md:w-[50vw]">
              <svg
                viewBox="0 0 980 938"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
              >
                <g clipPath={`url(#${id}_clip_mask)`}>
                  <path
                    opacity="0.58"
                    d="M966.804 916.712C890.594 916.712 814.407 916.83 738.197 916.665C696.476 916.571 680.722 905.268 667.926 865.532C640.011 778.821 612.635 691.945 584.696 605.234C576.925 581.1 579.954 560.163 595.027 538.896C677.646 422.271 759.562 305.176 841.242 187.892C857.607 164.394 877.469 151.798 907.216 153.091C944.781 154.712 982.464 153.419 1020.08 153.49C1061.89 153.584 1075.32 163.195 1087.18 202.955C1132.21 354.148 1177.1 505.41 1221.85 656.697C1236.76 707.125 1251.69 757.554 1265.4 808.312C1270 825.301 1272.37 843.278 1272.98 860.902C1273.95 888.467 1263.36 903.271 1237.01 910.579C1221.85 914.785 1205.53 916.336 1189.71 916.454C1115.4 917.041 1041.07 916.712 966.757 916.712"
                    fill="#E4E4E4"
                  />
                  <mask
                    id={shapeMask}
                    style={{ maskType: 'alpha' }}
                    maskUnits="userSpaceOnUse"
                    x="14"
                    y="-289"
                    width="2129"
                    height="1103"
                  >
                    <path
                      d="M1008.22 275.783C885.732 100.485 763.038 -74.6768 640.038 -249.602C620.92 -276.763 594.595 -289.701 560.047 -288.82C501.846 -287.296 443.544 -288.515 385.31 -288.38C328.023 -288.278 309.041 -274.325 292.359 -218.545C232.839 -19.4391 173.657 179.803 114.238 378.943C89.1647 463.002 63.8543 546.993 38.6116 630.984C29.2048 662.243 16.245 693.198 14.1809 726.083C13.4365 738.208 14.8915 750.705 20.3732 761.543C29.9153 780.373 50.387 794.462 69.4037 802.387C90.1799 811.023 112.919 813.563 135.251 813.529C357.428 813.224 579.571 813.529 801.748 813.292C852.504 813.224 878.187 797.002 893.583 749.723C937.098 616.252 978.345 482.069 1021.29 348.395C1030.08 320.996 1023.42 297.56 1008.19 275.749"
                      fill="white"
                    />
                  </mask>
                  <g mask={`url(#${shapeMask}`}>
                    <rect
                      x="-461"
                      y="-176"
                      width="1889"
                      height="1114"
                      fill={`url(#${id}_pattern)`}
                    />
                    <path
                      opacity="0.5"
                      d="M-217.161 1269.84C-86.3601 1269.84 44.4004 1270.04 175.201 1269.76C246.807 1269.59 273.846 1250.2 295.807 1182.01C343.719 1033.22 390.704 884.143 438.656 735.349C451.994 693.937 446.796 658.009 420.926 621.516C279.124 421.391 138.532 220.46 -1.65795 19.2059C-29.7442 -21.1175 -63.8347 -42.7308 -114.89 -40.513C-179.363 -37.7307 -244.038 -39.9485 -308.592 -39.8275C-380.36 -39.6662 -403.409 -23.174 -423.758 45.0532C-501.046 304.494 -578.092 564.056 -654.896 823.658C-680.484 910.191 -706.112 996.725 -729.645 1083.82C-737.543 1112.98 -741.613 1143.83 -742.661 1174.07C-744.313 1221.37 -726.139 1246.77 -680.927 1259.31C-654.896 1266.53 -626.89 1269.19 -599.731 1269.39C-472.194 1270.4 -344.617 1269.84 -217.08 1269.84"
                      fill="#3C3C3C"
                    />
                  </g>
                </g>
                <defs>
                  <pattern
                    id={`${id}_pattern`}
                    patternContentUnits="objectBoundingBox"
                    width="1"
                    height="1"
                  >
                    <use
                      xlinkHref={`#${id}_image`}
                      transform="matrix(0.0004 0 0 0.000678276 0 -0.0639869)"
                    />
                  </pattern>
                  <clipPath id={`${id}_clip_mask`}>
                    <rect width="980" height="938" fill="white" />
                  </clipPath>
                  <image
                    id={`${id}_image`}
                    width="2500"
                    height="1663"
                    xlinkHref={
                      blok.images.length > 0 && blok.images[0].filename
                    }
                  />
                </defs>
              </svg>
            </div>
          </div>
        </div>
      </Container>
    </Section>
  );
};

export default MaskedImage;
